<!------------------------------

Hide Proxy Element

------------------------------->

@if (!isInModalContext) {
  <div class="drag-dummy position-absolute" style="top:0; left: 0">
  </div>
}

<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  @if (permissionService.hasPermission(permissionService.Permission.medium_group_create)) {
    <button
      type="button"
      sbTooltip="{{ 'lang.mediumGroups.createMotiveGroup' | translate }}"
      container="body"
      (click)="toggleSideBar()"
      sb-button-primary
      [color]="'green'"
      [iconButton]="true"
      [icon]="'plus'"
      [loading]="loading()"
    >
    </button>
  }

  <button
    (click)="requestDebounced()" [disabled]="loading()"
    sb-button-primary [color]="'blue'"
    [loading]="loading()"
    type="button"
    [iconButton]="true"
    [icon]="'refresh'"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}"
    container="body"
    placement="top">
  </button>

  @if (permissionService.hasPermission(permissionService.Permission.medium_group_category_list)) {
    <button
      type="button"
      sb-button-primary
      [disabled]="loading()"
      [color]="'blue'"
      [loading]="loading()"
      [iconButton]="true"
      [icon]="'category'"
      [sbRouterLink]="util.RoutingID.mediumGroupCategories"
      sbTooltip="{{ 'lang.globals.mediumGroupCategories' | translate }}"
      container="body"
      placement="top">
    </button>
  }
</ng-container>

@if (!isInModalContext) {
  <sb-comp-side-panel (showChange)="showSideBar=$event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                      [sidebarTemplate]="compSidePanelTemplate" [width]="400">

  </sb-comp-side-panel>
}

<ng-template #sidebarHeader>
  <div class="d-flex">
    <h4 [innerHTML]="'lang.mediumGroupSettingsEdit.mediumGroupDetails' | translate"></h4>
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-medium-group-settings-edit [mediumGroup]="null" [selectedFolder]="selectedFolder"
                                      (mediumGroupChangedEmitter)="handleMediumGroupChanged($event)"></sb-page-medium-group-settings-edit>
</ng-template>

<div (dragover)="moveDragElement($event)" class="tw-flex tw-flex-col tw-h-full md:tw-flex-row tw-gap-5">
  <!------------------------------

  Proxy Element

  ------------------------------->

  <div *ngIf="dragging" [style.left.px]="dragItemStyle.left" [style.top.px]="dragItemStyle.top"
       class="dragging-item position-absolute tw-w-auto tw-drop-shadow" style="z-index: 70;">
    <div class="position-relative card card-border-radius">
      <div class="card-body">
        <div class="d-flex flex-column align-items-center">
          <sb-comp-image-name-wrapper [medium]="[dragging?.preview]" [still]="true">
            <span firstLine class="tw-cursor-pointer" [innerHtml]="dragging?.name|truncate:30"></span>
          </sb-comp-image-name-wrapper>
        </div>
      </div>
    </div>
  </div>

  <!------------------------------

Folder

------------------------------->
  <div class="md:tw-w-1/4">
    <div
      class="tw-flex tw-drop-shadow-sm-sbGray-300 tw-flex-col tw-rounded-xl tw-w-full tw-h-full dark:tw-drop-shadow-none tw-border tw-border-solid tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-bg-sbGray-50/30 dark:tw-bg-[#2e3648]">
      <div
        class="tw-flex tw-justify-between tw-items-center tw-h-[60px] tw-px-5 tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-flex-wrap tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-rounded-t-xl">
        <div class="tw-text-lg tw-font-semibold">{{ 'lang.headlines.folder' | translate }}</div>
      </div>
      <table class="table table-hover">
        <tbody class="*:tw-cursor-pointer">
        <tr (click)="toggleFolder(null, false)" (dragleave)="dragOut($event)" (dragover)="dragOver($event, -2)"
            (drop)="drop($event, null)"
            [ngClass]="{
            '!tw-bg-sbBlue-100 *:dark:!tw-bg-sbGrayBlue-930' : !selectedFolder && !folderView && folderDragoverId !== -2,
            '!tw-bg-sbBlue-200 *:dark:!tw-bg-sbGrayBlue-800' : folderDragoverId === -2
            }"
            class="">
          <td colspan="100">
            <div class="tw-flex tw-gap-2.5">
              <sb-icon icon="folder"></sb-icon>
              <span>{{ 'lang.globals.allMotiveGroups' | translate }}</span>
            </div>
          </td>
        </tr>
        <tr (click)="toggleFolder(null)" (dragleave)="dragOut($event)" (dragover)="dragOver($event, -1)"
            (drop)="drop($event, null)"
            [ngClass]="{
            '!tw-bg-sbBlue-100 *:dark:!tw-bg-sbGrayBlue-930' : !selectedFolder && folderView && folderDragoverId !== -1,
            '!tw-bg-sbBlue-200 *:dark:!tw-bg-sbGrayBlue-800' : folderDragoverId === -1
            }"
            class="">
          <td colspan="100">
            <div class="tw-flex tw-gap-2.5">
              <sb-icon icon="folder"></sb-icon>
              <span>{{ 'lang.globals.noFolderMotiveGroups' | translate }}</span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="tw-px-5 tw-py-5 tw-border-0 tw-border-b tw-border-solid tw-flex-wrap tw-border-sbGray-500 dark:tw-border-sbGray-50">
        <div
          class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-group tw-w-fit tw-text-nowrap tw-flex-1 tw-mb-2 tw-gap-2.5">
          <div
            class="tw-text-lg">
            {{ 'lang.globals.ownFolder' | translate }}
          </div>
        </div>
        <sb-simple-search-bar
          #searchBar
          (submitted)="doFolderSearch($event)"
          (changed)="doFolderSearch($event)"
          [searchTerm]="folderSearch"
          [debounce]="true"
          [showExactMatch]="true"
          [exactMatch]="folderExactMatch"
          class="tw-w-full"
        >
        </sb-simple-search-bar>

        @if (!isInModalContext) {
          <button
            class="tw-w-full tw-mt-4"
            type="button"
            (click)="toggleFolderCreation($event)"
            [disabled]="showSideBar"
            sb-button-secondary
            [color]="'green'"
            [icon]="'plus'"
            [loading]="loading()"
          >
            {{ 'lang.globals.createFolder' | translate }}
          </button>
        }
      </div>
      @if (!isInModalContext) {

        <div
          class="tw-overflow-hidden tw-w-full tw-bg-sbGray-100 tw-p-2 dark:tw-bg-sbGray-800 tw-transition-all tw-ease-in-out tw-duration-300"
          [ngClass]="{
                  'tw-h-12': folderCreationMode,
                  'tw-h-0 tw-py-0': !folderCreationMode
                  }"
        >
          <div class="tw-flex tw-items-center tw-gap-3">
            <input #folderInput [(ngModel)]="folderName" class="tw-input tw-w-full"
                   placeholder="{{'lang.globals.folderName' | translate}}"
                   type="text" />
            <button
              type="button"
              sb-button-primary
              [color]="'green'"
              [iconButton]="true"
              [icon]="'checked'"
              (click)="createNewFolder()" [disabled]="!folderName || folderCreationInProgress"
            >
            </button>
            <button
              type="button"
              sb-button-primary
              [color]="'red'"
              [iconButton]="true"
              [icon]="'cancel'"
              (click)="toggleFolderCreation($event)"
            >
            </button>
          </div>
        </div>
      }
      <div class="tw-max-h-[800px] tw-overflow-y-auto custom-scrollbar tw-w-full">
        <table class="table table-hover tw-mb-3">
          <tbody class="*:tw-cursor-pointer">
            @for (folder of mediumGroupFolders; track folder.id) {

              <tr (click)="toggleFolder(folder)" (dragleave)="dragOut($event)" (dragover)="dragOver($event, folder?.id)"
                  (drop)="drop($event, folder)"
                  [ngClass]="{
                  '!tw-bg-sbBlue-100 *:dark:!tw-bg-sbGrayBlue-930' : folder.id === selectedFolder?.id,
                  '!tw-bg-sbBlue-200 *:dark:!tw-bg-sbGrayBlue-800' : folderDragoverId === folder.id
                  }"
                  class="*:!tw-border-0">
                <td>
                  <div class="tw-flex tw-gap-2.5">
                    <sb-icon icon="folder"></sb-icon>
                    <span [innerHTML]="folder.name | truncate : 20"></span>
                  </div>
                </td>
                <td>
                  <div class="tw-flex tw-gap-2.5">
                    <sb-icon icon="motives"></sb-icon>
                    <!--
                    <div
                      class="tw-flex tw-w-fit tw-text-sbBlue-500 dark:tw-text-white dark:tw-bg-sbGrayBlue-800 tw-rounded-full tw-bg-sbBlue-50 tw-py-1 tw-px-3"
                      sbTooltip="{{util.formatBytes(folder.folderSize)}}"
                    >
                    -->
                    <div>
                      {{ folder.elementsCount }}
                    </div>
                  </div>
                </td>
                <td class="text-right">
                  @if (!isInModalContext) {
                    <sb-icon (click)="deleteFolder($event, folder)" class="red" icon="trash"></sb-icon>
                  }
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="100">
                  @if (folderSearch) {
                    <i class="tw-font-light"> - {{ 'lang.globals.noFolderFound' |translate }} - </i>
                  } @else {
                    <i class="tw-font-light"> - {{ 'lang.globals.noOwnFolder' |translate }} - </i>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!------------------------------

         Medium-Groups

   ------------------------------->

  <div class="md:tw-w-3/4">
    @let isExpanded = checkExpansion();
    @let ordering = orderOption();

    <sb-table-wrapper-new
      headline="{{'lang.headlines.motiveGroups' | translate}}"
      [itemsData]="mediumGroups()"
      (paginationChange)="requestDebounced($event)"
      [loading]="loading()" [itemName]="'mediumGroups'" [isInModalContext]="isInModalContext"
      [isSplitscreen]="true"
      [isFilterPanelOpen]="isExpanded">
      <!------------------------------

   Filter

 ------------------------------->
      <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
        <sb-filter-panel
          #FilterPanelRef
          (filterChange)="applyFiltering($event)"
          [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
          [config]="filterConfig"
          filterID="search"
        >
          <sb-filter-section *ngPermissions="permissionService.Permission.company_list" title="{{'lang.globals.companies' | translate}}"
                             icon="company">
            <sb-filter-dto-list-select filterID="companies" [isSingleSelect]="true" [endpoint]="api.shared_Company_retrieveAll.bind(api)">
            </sb-filter-dto-list-select>
          </sb-filter-section>
          <sb-filter-section *ngPermissions="permissionService.Permission.medium_group_category_list"
                             title="{{'lang.globals.mediumGroupCategories' | translate}}"
                             icon="category">
            <sb-filter-dto-list-select filterID="mediumGroupCategories" [endpoint]="api.mm_MediumGroupCategory_retrieveAll.bind(api)">
            </sb-filter-dto-list-select>
          </sb-filter-section>
          <hr>
          <div class="tw-mx-3 tw-gap-2.5 tw-flex tw-flex-col tw-mb-4">
            <div
              #filterPanelOrder
              class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-group tw-w-fit"
              [ngClass]="{'tw-cursor-pointer': !isExpanded}"
              (click)="!isExpanded?openFilterPanel(filterPanelOrder):scrollToFilterPanelElement(filterPanelOrder)">
              <sb-icon class="" [ngClass]="{'tw-ml-2.5': !isExpanded}"
                       icon="sort"></sb-icon>
              <div class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
                   [ngClass]="{
      'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5 tw-flex': isExpanded,
    }">{{ 'lang.globals.order' | translate }}
              </div>
            </div>
            <div class="tw-flex tw-flex-grow tw-gap-2.5">

              @let fpOrderOption = filterPanelOrderOption();
              <sb-button-dropdown
                [selectedValue]="fpOrderOption.value" [items]="allOrderOptions|omit: 'direction'"
                (outputChange)="setToOrderFilterPanel($event)"
                [openDirection]="'Up'"
                class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left"
                [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
              >
              </sb-button-dropdown>
              <sb-segment-control
                [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
                [selectedOption]="{value: fpOrderOption.direction}"
                [options]="[{value: 'asc', icon: 'sortUpFilled' },{value: 'desc', icon: 'sortDownFilled' }]"
                (selectedOptionChange)="setOrderDirectionFilterPanel($event.value)"
              ></sb-segment-control>
            </div>
          </div>
        </sb-filter-panel>
      </div>
      <!------------------------------

            Table Header

      ------------------------------->
      <ng-template #thead>
        <tr>
          @if (!isInModalContext) {
            <th>
              <sb-icon icon="drag"></sb-icon>
            </th>
          }
          @if (!folderView && !selectedFolder) {
            <th>{{ 'lang.headlines.folder' | translate }}</th>
          }
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_MediumGroup_retrieveAll_order.NAME)"
              [ngClass]="{'table--sorted': ordering?.value===mm_MediumGroup_retrieveAll_order.NAME}">
            {{ 'lang.globals.name' | translate }}
            @if (ordering.value === mm_MediumGroup_retrieveAll_order.NAME) {
              @if (ordering.direction === 'desc') {
                <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              } @else {
                <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
              }
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_MediumGroup_retrieveAll_order.COMPANY)"
              [ngClass]="{'table--sorted': ordering?.value===mm_MediumGroup_retrieveAll_order.COMPANY}">
            {{ 'lang.globals.company' | translate }}
            @if (ordering.value === mm_MediumGroup_retrieveAll_order.COMPANY) {
              @if (ordering.direction === 'desc') {
                <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              } @else {
                <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
              }
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th>{{ 'lang.globals.category' |translate }}</th>
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_MediumGroup_retrieveAll_order.MODIFIED_AT)"
              [ngClass]="{'table--sorted': ordering?.value===mm_MediumGroup_retrieveAll_order.MODIFIED_AT}">
            {{ 'lang.globals.modifiedAt' | translate }}
            @if (ordering.value === mm_MediumGroup_retrieveAll_order.MODIFIED_AT) {
              @if (ordering.direction === 'desc') {
                <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              } @else {
                <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
              }
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_MediumGroup_retrieveAll_order.CREATED_AT)"
              [ngClass]="{'table--sorted': ordering?.value===mm_MediumGroup_retrieveAll_order.CREATED_AT}">
            {{ 'lang.globals.createdAt' | translate }}
            @if (ordering.value === mm_MediumGroup_retrieveAll_order.CREATED_AT) {
              @if (ordering.direction === 'desc') {
                <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              } @else {
                <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
              }
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="sticky-col last-col">
            {{ 'lang.globals.action' |translate }}
          </th>

        </tr>
      </ng-template>
      <!------------------------------

            Card Table Header

      ------------------------------->
      <ng-template #tCardHead>
        <tr>
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_MediumGroup_retrieveAll_order.NAME)"
              [ngClass]="{'table--sorted': ordering?.value===mm_MediumGroup_retrieveAll_order.NAME}">
            {{ 'lang.globals.name' | translate }}
            @if (ordering.value === mm_MediumGroup_retrieveAll_order.NAME) {
              @if (ordering.direction === 'desc') {
                <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              } @else {
                <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
              }
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_MediumGroup_retrieveAll_order.COMPANY)"
              [ngClass]="{'table--sorted': ordering?.value===mm_MediumGroup_retrieveAll_order.COMPANY}">
            {{ 'lang.globals.company' | translate }}
            @if (ordering.value === mm_MediumGroup_retrieveAll_order.COMPANY) {
              @if (ordering.direction === 'desc') {
                <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              } @else {
                <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
              }
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_MediumGroup_retrieveAll_order.MODIFIED_AT)"
              [ngClass]="{'table--sorted': ordering?.value===mm_MediumGroup_retrieveAll_order.MODIFIED_AT}">
            {{ 'lang.globals.modifiedAt' | translate }}
            @if (ordering.value === mm_MediumGroup_retrieveAll_order.MODIFIED_AT) {
              @if (ordering.direction === 'desc') {
                <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              } @else {
                <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
              }
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_MediumGroup_retrieveAll_order.CREATED_AT)"
              [ngClass]="{'table--sorted': ordering?.value===mm_MediumGroup_retrieveAll_order.CREATED_AT}">
            {{ 'lang.globals.createdAt' | translate }}
            @if (ordering.value === mm_MediumGroup_retrieveAll_order.CREATED_AT) {
              @if (ordering.direction === 'desc') {
                <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              } @else {
                <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
              }
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="!tw-w-auto"><!-- empty header for minimal header with on the others --></th>
        </tr>
      </ng-template>
      <!------------------------------

          Table Body

      ------------------------------->


      <ng-template #tbody let-mediumGroup>
        <tr>
          @if (!isInModalContext) {
            <td style="width: 0; white-space: nowrap">
              <button (dragend)="dragEnd()" (dragstart)="dragStart({event: $event, item: mediumGroup})"
                      [draggable]="mediumGroup?.id" class="btn btn-hover-primary">
                <sb-icon icon="drag"></sb-icon>
              </button>
            </td>
          }
          @if (!folderView && !selectedFolder) {
            <td class="">
              <sb-icon icon="folder" class="tw-mr-1"></sb-icon>
              {{ mediumGroup?.folder?.name ?? '-' }}
            </td>
          }
          <td>
            <sb-comp-image-name-wrapper [medium]="mediumGroup?.preview">
              <sb-comp-link firstLine
                            [title]="mediumGroup?.name | truncate : 30"
                            [permission]="permissionService.Permission.medium_group_show"
                            [condition]="!isInModalContext"
                            [link]="util.RoutingID.mediumGroupEdit"
                            [pathParams]="[{id: 'mediumGroupID', value: mediumGroup?.id}]"
                            [tooltip]="'lang.globals.openDetails' | translate">
              </sb-comp-link>
              <span secondLine>{{ mediumGroup?.description }} </span>
              <span
                thirdLine>{{ mediumGroup?.mediaCount }} {{ mediumGroup?.mediaCount === 1 ? ('lang.globals.motive'|translate) : ('lang.globals.motives'|translate) }}</span>≈
              <sb-tags fourthLine *ngPermissions="[permissionService.Permission.tag_list]" [tags]="mediumGroup.tags"
                       [dtoType]="tagService.TaggableDTO.MediumGroup" [dtoId]="mediumGroup.id"></sb-tags>
            </sb-comp-image-name-wrapper>
          </td>
          <td>
            <div class="tw-flex tw-gap-1">
              <sb-icon icon="company"></sb-icon>
              <sb-comp-link
                [condition]="!isInModalContext"
                [title]="mediumGroup?.company?.name ?? '-'"
                [link]="util.RoutingID.companyDetails"
                [pathParams]="[{id: 'companyID', value: mediumGroup?.company?.id}]"
                [permission]="permissionService.Permission.company_show">
              </sb-comp-link>
            </div>
          </td>
          <td>
            <div class="tw-flex tw-gap-1">
              <sb-icon icon="templates"></sb-icon>
              <div [innerHTML]="(mediumGroup?.category?.name ?? '-') | truncate: 30"></div>
            </div>
          </td>
          <td>
            <sb-comp-display-modified [data]="mediumGroup" [hideTooltip]="true"></sb-comp-display-modified>
          </td>
          <td>
            <sb-comp-display-created [data]="mediumGroup"></sb-comp-display-created>
          </td>
          <td class="tw-text-center sticky-col last-col">
            <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: mediumGroup}"></ng-container>
          </td>
        </tr>
      </ng-template>

      <!------------------------------

      Card Element

      ------------------------------->

      <ng-template #card let-mediumGroup>
        <sb-table-card
          class="tw-rounded-xl"
        >
          <div table-card-header>
          </div>
          <div table-card-header-more>
            <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: mediumGroup}"></ng-container>
          </div>
          <div table-card-img>
            <sb-comp-medium [medium]="mediumGroup.preview" [customHeight]="'240px'" [customWidth]="'100%'" [thumbnailSize]="'M'"
                            [still]="true"></sb-comp-medium>
          </div>
          <div table-card-sub-header>
            <button sb-button-primary type="button" [color]="'blue'" [iconButton]="true" [icon]="'drag'" (dragend)="dragEnd()"
                    (dragstart)="dragStart({event: $event, item: mediumGroup})"
                    [draggable]="mediumGroup?.id">
            </button>
          </div>
          <div table-card-body>
            <div
              class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:tw-py-3.5 *:sm:tw-py-5">
              <sb-table-card-element
                class="!tw-col-span-4"
                [orientation]="'left'" [headline]="'lang.globals.medium' | translate">
                <sb-comp-name-wrapper>
                  <sb-comp-link firstLine
                                [title]="mediumGroup?.name | truncate : 30"
                                [permission]="permissionService.Permission.medium_group_show"
                                [condition]="!isInModalContext"
                                [link]="util.RoutingID.mediumGroupEdit"
                                [pathParams]="[{id: 'mediumGroupID', value: mediumGroup?.id}]"
                                [tooltip]="'lang.globals.openDetails' | translate">
                  </sb-comp-link>
                  <span secondLine>{{ mediumGroup?.description }}</span>
                  <span
                    thirdLine>{{ mediumGroup?.mediaCount }} {{ mediumGroup?.mediaCount === 1 ? ('lang.globals.motive'|translate) : ('lang.globals.motives'|translate) }}</span>
                  <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="mediumGroup?.id"
                           [dtoType]="tagService.TaggableDTO.MediumGroup"
                           [tags]="mediumGroup?.tags" fourthLine></sb-tags>
                </sb-comp-name-wrapper>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.globals.customer' | translate " [orientation]="'left'"
                                     [classes]="'tw-gap-2'">
                <sb-icon icon="company"></sb-icon>
                <span [innerHTML]="(mediumGroup?.company?.name ?? ('lang.globals.unknown' | translate)) | truncate : 20"></span>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.headlines.folder' | translate " [orientation]="'right'"
                                     [classes]="'tw-gap-2'">
                <sb-icon icon="folder"></sb-icon>
                <span [innerHTML]="(mediumGroup?.folder?.name ?? '-') | truncate : 20"></span>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.globals.category' | translate " [orientation]="'left'"
                                     [classes]="'tw-gap-2'">
                <sb-icon icon="category"></sb-icon>
                <span [innerHTML]="(mediumGroup?.category?.name ?? '-') | truncate : 20"></span>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.globals.modifiedAt' | translate " [orientation]="'right'"
                                     [classes]="'tw-gap-2'">
                <sb-comp-display-modified [data]="mediumGroup" [hideTooltip]="true" [reverse]="true"></sb-comp-display-modified>
              </sb-table-card-element>
              <sb-table-card-element class="!tw-border-0" [headline]="'lang.globals.createdAt' | translate " [orientation]="'left'"
                                     [classes]="'tw-gap-2'">
                <sb-comp-display-created [data]="mediumGroup"></sb-comp-display-created>
              </sb-table-card-element>

            </div>
          </div>

        </sb-table-card>
      </ng-template>

    </sb-table-wrapper-new>
  </div>
</div>

<ng-template #ActionButtons let-item>
  <div class="tw-flex tw-gap-2.5">
    @if (isInModalContext) {

      <button (click)="selectGroup(item)"
              sb-button-secondary
              type="button"
              [color]="'blue'"
              sbTooltip="{{ 'lang.globals.select' | translate }}"
              [iconButton]="true"
              icon="selection">
      </button>

    } @else {
      <!-- not in modal -->
      <sb-split-button
        [splitButtonItems]="item?.sbButtons ?? []"
        (selectedAction)="resolveSplitButtonAction(item, $event)"
      ></sb-split-button>
    }

  </div>
</ng-template>
